import { Outlet } from "react-router-dom";
import { ProtectedRoute } from "./guard-route";
import { AppSidebar } from "./app-sidebar";
import { AppHeader } from "./AppHeader";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { A11Y, MAIN_CONTENT_ID } from "@/lib/a11y";
import { IdleTimeoutGuard } from "@/hooks/useIdleTimeout";

function AdminLayout() {
  return (
    <ProtectedRoute>
      <IdleTimeoutGuard />
      <SidebarProvider defaultOpen={true}>
        <div className="flex min-h-svh w-full min-w-0 overflow-hidden bg-background">
          <AppSidebar />
          <SidebarInset
            id={MAIN_CONTENT_ID}
            tabIndex={-1}
            aria-label={A11Y.mainContent}
            className="min-w-0 outline-none"
          >
            <AppHeader />
            <main className="flex min-h-0 min-w-0 flex-1 flex-col overflow-x-auto overflow-y-auto bg-background">
              <Outlet />
            </main>
          </SidebarInset>
        </div>
      </SidebarProvider>
    </ProtectedRoute>
  );
}

export default AdminLayout;
